import vuexI18n from 'vuex-i18n';
import localdataService from '../services/localdata.service.js';

export default {
  install: (Vue, { state, languages, fallbackLanguage }) => {
    Vue.use(vuexI18n.plugin, state.store);
    languages.forEach(l => {
      Vue.i18n.add(l.name, l.file);
    });
    Vue.i18n.fallback(fallbackLanguage || 'en');
    Vue.i18n.set(localdataService.get('lang') || fallbackLanguage || 'en');

    Vue.prototype.$t = Vue.i18n.translate;
  }
}



// WEBPACK FOOTER //
// ./_common/plugins/i18n.plugin.js